import React from 'react';
import { connect } from 'react-redux';
import {
  EnumTableOrderStatus,
  EnumToggleType,
} from '../../../../constants/enum';
import { trans } from '../../../../localization';
import { updateOrderInfo, updateOrderStatus } from '../actions';
import { startConfirm } from '../../../../layout/components/UniversalModal/actions';

class OrderActionColumn extends React.Component {
  onConfirmClicked = () => {
    const { data } = this.props;
    const { id } = data;
    const updateData = {
      order_id: id,
      order_status: EnumTableOrderStatus.CONFIRMED.id,
    };
    const { startConfirmConnect, updateOrderStatusConnect } = this.props;
    startConfirmConnect({ onOk: () => updateOrderStatusConnect(updateData) });
  };

  onClickConfirmOrderCompleted = () => {
    const { data, startConfirmConnect, updateOrderInfoConnect } = this.props;
    const { adult_number, id, children_number } = data;
    const requestData = {
      order_id: id,
      real_adult_number: adult_number,
      children_number,
    };
    startConfirmConnect({ onOk: () => updateOrderInfoConnect(requestData) });
  };

  render() {
    const { data, openRejectModal } = this.props;
    const {
      is_show_reject_accept_button,
      is_editable,
      is_show_confirm_button,
      id,
    } = data;
    return (
      <div>
        {is_show_reject_accept_button === EnumToggleType.ON.id && (
          <div className="order-action-buttons">
            <button
              type="button"
              className="btn btn-block btn-green"
              onClick={this.onConfirmClicked}
            >
              {trans('confirm')}
            </button>
            <button
              type="button"
              className="btn btn-block btn-decline"
              onClick={() => openRejectModal(id)}
            >
              {trans('decline')}
            </button>
          </div>
        )}
        {is_editable === EnumToggleType.ON.id && (
          <i
            className="fas fa-edit icon-hover"
            onClick={() => this.props.openReportModal(id)}
            title={trans('edit_booking_order')}
          />
        )}
        {is_editable === EnumToggleType.ON.id && (
          <div
            className="edit-icon"
            onClick={() => this.props.openBillCodeAndTotalBillModal(data)}
            title={trans('edit_bill_code_and_total_bill_order')}
          />
        )}
        {is_show_confirm_button === EnumToggleType.ON.id && (
          <i
            className="fas fa-check icon-hover"
            style={{ color: '#189210' }}
            title={trans('confirm_booking_order')}
            onClick={this.onClickConfirmOrderCompleted}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = {
  updateOrderStatusConnect: updateOrderStatus,
  updateOrderInfoConnect: updateOrderInfo,
  startConfirmConnect: startConfirm,
};

export default connect(
  null,
  mapDispatchToProps,
)(OrderActionColumn);



// WEBPACK FOOTER //
// ./foody/src/pages/Table/TableManagement/components/OrderActionColumn.jsx